<template>
	<div class="p_box" id="box">
		<el-breadcrumb separator="/" id="head">
			<el-breadcrumb-item :to="{ path: '/Homet' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item>慧题库</el-breadcrumb-item>

		</el-breadcrumb>
		<!-- 		<div class="mine_header p_m_t_30" id="heads">
			<div class=" header_left p_flex p_f_a p_f_c">
				<div class="p_flex p_f_a small_hand" v-for="(item, index) in headerList" :key="index"
					 @click="goHeader(index)">
					<div :class="[headerIndex == index ? 'tababr_com' : '']">{{ item.name }}</div>
				</div>
			</div>
		</div> -->
		<div v-show="headerIndex ==0">
			<div id="" :style="{ height: height + 'px' }" style="background-color: #FFFFFF;">
				<div class="mine_comm p_m_t_20" id="headb">
					<hui-question-header @Headerindex="Headerindex" @headerindexs="headerindexs"
						@headerindexss="headerindexss" @headerindexsss="headerindexsss"
						@headerindexssss="headerindexssss" @headerindexsssss="headerindexsssss"
						@headerindexssssss="headerindexssssss" @headerindexsssssss="headerindexsssssss"
						@headerindexssssssss="headerindexssssssss"></hui-question-header>
				</div>
				<el-dialog title="习题篮" :visible.sync="open" width="30%" center>
					<div class="mes">
						<div>
							<span>作业名称</span>
							<input v-model="jobname" placeholder="请选择作业名称" maxlength="12"></input>
							<span style="color:#67C23A">{{calculatebyte(jobname)}}/12</span>
						</div>
						<div>
							<span>选择年级</span>
							<el-select v-model="gradName" placeholder="请选择年级" @change="getGradId">
								<el-option v-for="item in gradList" :key="item.id" :label="item.name"
									:value="item.name">
								</el-option>
							</el-select>
						</div>
						<div>
							<span>选择学科</span>
							<el-select v-model="subjectName" placeholder="请选择学科" @change="getSubjectId">
								<el-option v-for="item in subjectList" :key="item.id" :label="item.name"
									:value="item.name">
								</el-option>
							</el-select>
						</div>
					</div>
					<span slot="footer" class="dialog-footer">
						<el-button @click="cancel()">取 消</el-button>
						<el-button type="primary" @click="groupIssued()">确 定</el-button>
					</span>
				</el-dialog>
				<div :class="oen?'active': 'basket'">
					<div class="basket-tit" @click="changoen">
						<p><span class="icona-gouwulan"></span><em>试题篮</em><b
								class="basket-num">{{ questionList.length }}</b>
							<span><span class="icona-gouwuleft"></span></span>
						</p>
					</div>
					<div class="basket-con">
						<div class="basket-count">
							<div class="basket-head">
								共计：（<span>{{ questionList.length }}</span>）道题
							</div>
							<div class="baskrt-list">
								<div style="margin: 10px;font-size: 10px;">
									选择：（<span>{{ xz }}</span>）道题
								</div>
								<div style="margin: 10px;font-size: 10px;">
									填空：（<span>{{ tk }}</span>）道题
								</div>
								<div style="margin: 10px;font-size: 10px;">
									问答：（<span>{{ wd }}</span>）道题
								</div>
							</div>
						</div>
						<div class="basket-foot" style="margin-top: -38px;">
							<el-button @click="commit()" class="btn">生成组卷</el-button>
						</div>
					</div>
				</div>
				<div class="mine_list p_m_t_20">
					<hui-sheet :age="age" :ages="ages" :agess="agess" :agesss="agesss" :agessss="agessss"
						:agesssss="agesssss" :agessssss="agessssss" :agesssssss="agesssssss" :agessssssss="agessssssss"
						:r="r" :dataList.sync="questionList" :xz1.sync="xz" :tk1.sync="tk" :wd1.sync="wd"
						:count.sync="count" ref="addreport"></hui-sheet>
				</div>
			</div>
		</div>
		<el-dialog title="题数模板选择" :visible.sync="centerDialogVisible" width="50%" :close-on-click-modal="false"
			:show-close="false" center>
			<el-row>
				<el-col :span="6" v-for="(item,index) in templateList" :key="index">
					<el-card class="box-card" @click.native="chooseTemplate(item)">
						<div>
							<span>选择：{{item.xz}}</span>
						</div>
						<div style="margin-top: 10px;">
							<span>填空：{{item.tk}}</span>
						</div>
						<div style="margin-top: 10px;">
							<span>问答：{{item.wd}}</span>
						</div>
					</el-card>
				</el-col>
			</el-row>
			<span slot="footer" class="dialog-footer">
				<el-button @click.native="noChooseTemplate()" style="background: #67C23A;color: #FFFFFF">不使用模板
				</el-button>
			</span>
		</el-dialog>

		<el-dialog title="待生成试卷题目" :visible.sync="centerDialogVisible1" width="50%" height="70%"
			:close-on-click-modal="false" center>
			<div class="el-dialog-div">
				<el-card class="list_box cardheader" v-for="(item, index) in questionList" :key="index"
					infinite-scroll-disabled="disabled">
					<div slot="header">
						<div>
							<span>题型：{{ item.qtpye }}</span>
							<el-divider direction="vertical" style="background-color: black;"></el-divider>
							<span v-if="item.diff  == '1.00'">难易度：简单</span>
							<span v-else-if="item.diff  == '2.00'">难易度：一般</span>
							<span v-else-if="item.diff  == '3.00'">难易度：中等</span>
							<span v-else-if="item.diff == '4.00'">难易度：困难</span>
							<span v-else-if="item.diff  == '5.00'">难易度：特难</span>
						</div>
					</div>
					<div :v-html="MathJax.MathQueue(item)"></div>
					<div class="latexDiv" v-html="item.title" style="margin-top: 20px;"></div>
					<div class="li-da">
						<div class="latexDiv" style="margin-top: 10px;" v-if="item.option_a">A:<span
								v-html="item.option_a"></span></div>

						<div class="latexDiv" style="margin-top: 10px;" v-if="item.option_b">B:<span
								v-html="item.option_b"></span></div>

						<div class="latexDiv" style="margin-top: 10px;" v-if="item.option_c">C:<span
								v-html="item.option_c"></span></div>

						<div class="latexDiv" style="margin-top: 10px;" v-if="item.option_d">D:<span
								v-html="item.option_d"></span></div>
					</div>
					<el-divider style="width:100%;border:1px dashed #EBEEF5;"></el-divider>
					<div class="p_flex p_f_a p_f_b p_m_t_20">
						<div class="p_flex type_size_16">
						</div>
						<div class="p_flex">
							<el-button type="info" plain size="mini" @click="usechild(item)"
								style="background: #67C23A;color: #FFFFFF">
								移除
							</el-button>
						</div>
					</div>
				</el-card>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button type="primary" style="background-color: #67C23A;color: #FFFFFF" @click="suretitle(index)">
					确定生成</el-button>
			</span>
		</el-dialog>


	</div>
</template>

<script>
	import HuiQuestionHeader from '../commponents/huiquestionHeader.vue';
	import HuiSheet from '../commponents/huiSheet.vue'
	import HuiBasket from '../commponents/huiBasket.vue'

	export default {
		name: 'HuiQuestion',
		components: {
			HuiQuestionHeader,
			HuiSheet,
			HuiBasket
		},
		data() {
			return {
				centerDialogVisible: true,
				centerDialogVisible1: false,
				oen: false,
				open: false,
				headerIndex: 0, //头部切换id
				headerList: [ //头部切换列表
					{
						id: 1,
						name: '习题'
					},
				],
				age: '', //学段id
				ages: '', //年级id
				agess: '', //学科id
				agesss: '', //教材版本id
				agessss: {}, //知识点id
				agesssss: '', //题型id
				agessssss: '', //难易程度id
				agesssssss: 0, //时间
				agessssssss: '', //题类id
				id: '',
				r: true,
				op: {},
				height: 0, //获取的高度
				jobname: '', //作业名称
				gradeId: '', //年级id
				gradName: '', //年级名称
				subjectId: '', //学科id
				subjectName: '', //学科名称
				onlineName: '', //线上线下名字
				subjectList: [], //学科列表
				gradList: [], //年级列表
				questionList: [], //习题篮列表
				teachid: '', //教师id
				templateList: [],

				xz: 0,
				tk: 0,
				wd: 0,

				count: [],

			};
		},
		created() {
			// console.log(this.$route.query.id)
			this.id = this.$route.query.id;
			this.questionList = []
			//教师id
			this.teachid = JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).id : ''
			//获取年级
			this.getGrad()
			//获取学科
			//this.getSubject()
			//获取题数模板
			this.getTemplate();
		},
		watch: {
			'$route.path': {
				immediate: true,
				handler(newVal, oldVal) {
					if (newVal == '/HuiQuestion') {
						let height = localStorage.getItem('height');
						if (height == '') {

						} else {
							this.height = height;
						}
					}
				}
			},
			count:{
				handler(newVal, oldVal) {
					document.getElementsByClassName('el-main')[0].scrollTop = 0
				},
				deep:true,
			}
		},
		beforeRouteLeave(to, form, next) {
			localStorage.removeItem('height');
			next();
		},
		mounted() {
			//获取屏幕高度
			this.indexInfo();


		},
		methods: {

			usechild(index) {
				debugger
				this.$refs.addreport.deleP(index);
			},
			noChooseTemplate() {
				sessionStorage.setItem('template', "noTemplate");
				this.centerDialogVisible = false;
			},
			chooseTemplate(e) {
				sessionStorage.setItem('template', JSON.stringify(e));
				this.centerDialogVisible = false;
			},
			getTemplate() {
				sessionStorage.setItem('template', {});

				this.$request.ajax(this).post("/HuiApiRequest/templist").then(res => {
					this.templateList = res.data
				})
			},
			calculatebyte(sTargetStr) {
				var sTmpStr, sTmpChar;
				var nOriginLen = 0;
				var nStrLength = 0;

				sTmpStr = new String(sTargetStr);
				nOriginLen = sTmpStr.length;

				for (var i = 0; i < nOriginLen; i++) {
					sTmpChar = sTmpStr.charAt(i);

					if (escape(sTmpChar).length > 4) {
						nStrLength += 2;
					} else if (sTmpChar != '/r') {
						nStrLength++;
					}
				}
				return nStrLength;
			},
			getdataList(val) {
				this.questionList = val
			},
			changoen() {
				this.oen = !this.oen
			},
			//获取年级id
			getGradId(name) {
				this.gradList.forEach((value, index) => {
					if (value.name == name) {
						this.gradeId = value.id
					}
				})
			},
			//获取年级
			getGrad() {
				this.$request.ajax(this).post("/Library/grade").then(res => { //年级
					this.gradList = res.data
				})
			},
			//获取学科
			getSubjectId(name) {
				let subjectId = ''
				this.subjectList.forEach((value, index) => {
					if (value.name == name) {
						subjectId = value.id
					}
				})
				//学科id对应
				switch (subjectId) {
					case "1":
						this.subjectId = "1";
						break;
					case "2":
						this.subjectId = "2";
						break;
					case "3":
						this.subjectId = "3";
						break;
					case "4":
						this.subjectId = "6";
						break;
					case "5":
						this.subjectId = "9";
						break;
					case "6":
						this.subjectId = "7";
						break;
					case "7":
						this.subjectId = "8";
						break;
					case "8":
						this.subjectId = "4";
						break;
					case "9":
						this.subjectId = "5";
						break;
				}
			},
			//获取学科id
			getSubject() {
				this.subjectList = []
				let obj = {}
				obj.id = this.agess
				obj.name = JSON.parse(localStorage.getItem('subjectName')).replace("\"", "").replace("\"", "")
				this.subjectList.push(obj)
			},
			//获取屏幕高度
			indexInfo() {
				let box = document.getElementById('box').offsetHeight;
				let head = document.getElementById('head').offsetHeight;
				// var heads = document.getElementById('heads').offsetHeight;
				let height = box - head - 30 - 20 - 20 - 20;
				let heights = localStorage.getItem('height');
				localStorage.setItem('height', height);
				this.height = height;
			},
			// 头部切换
			goHeader(i) {
				this.headerIndex = i;
				this.r = !this.r
				this.indexInfo();
			},
			Headerindex(i) { //学段
				this.age = i;
			},
			headerindexs(i) { //年级
				this.ages = i;
			},
			headerindexss(i) { //学科
				this.agess = i;
				this.getSubject()
			},
			headerindexsss(i) { //教材版本
				this.agesss = i;
			},
			headerindexssss(i) { //知识点
				this.agessss = i;
			},
			headerindexsssss(i) { //题型
				this.agesssss = i;
			},
			headerindexssssss(i) { //时间
				this.agessssss = i;
			},
			headerindexsssssss(i) { // 难易程度
				this.agesssssss = i;
			},
			headerindexssssssss(i) { //题类筛选
				this.agessssssss = i;
			},
			//组卷选择
			commit() {
				if (this.questionList.length != 0) {
					/* this.$confirm('是否提交到慧题库后台', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'info',
						center: true
					}).then(() => {
						this.open = !this.open
						this.$message({
							type: 'success',
							message: '已确定!'
						});
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消'
						});
					}); */
					this.centerDialogVisible1 = true;
				} else {
					this.$message({
						type: 'info',
						message: '请先添加题目'
					});
				}
			},
			suretitle() {
				this.centerDialogVisible1 = false;
				this.open = !this.open
			},
			cancel() {
				this.open = !this.open
				this.$message("已取消");
			},
			groupIssued() {
				console.log(this.questionList)
				console.log(this.jobname)
				console.log(this.gradeId)
				console.log(this.subjectId)
				if (!this.questionList || !this.jobname || !this.gradeId || !this.subjectId) {
					this.$message({
						type: 'warning',
						message: '请填写完整!'
					});
				} else {
					let data = {}
					data.grade = this.gradeId
					data.question_list = this.questionList
					this.$request.ajax(this).post('/api_teacher/question_createList', data).then((res) => {
						if (res.msg == 'success') {
							let data1 = {}
							data1.name = this.jobname
							data1.subject = this.subjectId
							data1.grade = this.gradeId
							data1.question_ids = res.data.id
							this.$request.ajax(this).post('/api_teacher/exercise_book_create', data1).then((
								res1) => {
								if (res1.msg == 'success') {
									this.$message({
										type: 'success',
										message: '组卷生成成功!'
									});
									this.open = false
									//this.$router.push({path: '/Mine', query: {id: '2'}})
									this.$router.push('/Mine?id=2');
								} else {
									this.$message({
										type: 'error',
										message: res1.msg
									});
									this.open = false
								}
							})
						}
					})
				}
			}

		}
	};
</script>
<style lang="scss" scoped>
	.list_box {
		//padding: 20px 0;
		border: 1px solid #EBEEF5;
		margin: 0 20px;
		margin-bottom: 10px;
		font-size: 15px;
		line-height: 50px;
		//text-align:center;
	}

	.el-dialog-div {
		height: 60vh;
		overflow-x: hidden;
	}

	.box-card {
		margin: 10%;
		align-items: center;
		display: flex;
		justify-content: center;
		height: 100px;
		color: #67C23A;
	}

	.el-card {}

	.el-card:hover {
		background-color: #67C23A;
		color: white;
	}

	.basket-tit p em {
		display: block;
		width: 1em;
		margin: 49px auto 0;
		line-height: 18px;
		font-weight: 400;
	}

	.basket-tit {
		position: absolute;
		left: 0;
		top: 0;
		width: 42px;
		height: 100%;
		background: #8fc320;
		cursor: pointer;
		font-size: 14px;
		color: #fff;
	}

	.basket-head {
		background: #d9fb91;
		height: 35px;
		line-height: 35px;
		font-size: 12px;
		color: #333;
		margin: 2px;
		padding-left: 13px;
	}

	.basket-num {
		background-color: #ff9a18;
		border-radius: 10px;
		color: #fff;
		font-size: 10px;
		height: 20px;
		line-height: 20px;
		position: absolute;
		right: -4px;
		text-align: center;
		top: 32px;
		width: 20px;
		z-index: 3;
	}

	.basket-tit span {
		position: absolute;
		bottom: 0;
		left: 0;
		width: 40px;
		height: 40px;
		border-top: 1px solid #FFBE8F;
		display: block;
	}


	.basket-con {
		float: left;
		width: 150px;
		border: 1px solid #DAD4CE;
		border-left: 0;
		//min-height: 215px;
	}

	.active {
		position: fixed;
		padding-left: 40px;
		right: -1px;
		top: 50%;
		margin-top: -150px;
		border-radius: 5px 0 0 5px;
		z-index: 999;
		width: 150px;
		height: 200px;
		background-color: wheat;

		.btn {
			margin-left: 20px;
			transform: translateY(81px);
			background-color: #00ad61;
			color: #FFFFFF;
		}
	}

	.basket {
		position: fixed;
		padding-left: 40px;
		right: -140px;
		top: 50%;
		margin-top: -150px;
		border-radius: 5px 0 0 5px;
		z-index: 999;
		width: 150px;
		height: 200px;
		background-color: wheat;

		.btn {
			margin-left: 20px;
			transform: translateY(81px);
			background-color: #00ad61;
			color: #FFFFFF;
		}
	}

	.mes {
		padding-left: 120px;

		div {
			margin-top: 10px;
		}
	}

	.p_box {
		position: relative;
		//width:1500px;
		max-width: 1200px;
		background-color: #ffffff;
	}

	.divs {
		margin-left: 530px;
	}

	.mine_header {
		background-color: #fafafa;
		height: 60px;
	}

	.header_left>div {
		height: 100%;
		position: relative;
	}

	.header_left>div:nth-child(2) {
		margin-left: 50px;
	}

	.header_left>div:nth-child(3) {
		margin-left: 50px;
	}

	.header_left {
		height: 100%;
	}

	.header_heng {
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translateX(-50%);
		width: 80%;
		height: 2px;
		background-color: #000000;
	}

	.tababr_com {
		font-weight: bold;
	}

	.heaer_btn {
		margin-top: 10px;
		margin-left: 440px !important;
	}

	.mine_comm {
		padding: 0 20px;
		background-color: #ffffff;
	}

	.mine_list {
		// padding: 0 220px;
		background-color: #ffffff;
		padding: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/homet/huiquestion/huiquestion.vue